import React from "react";
import Btn from "../Components/Products/SubCategory/Btn";
import Transl from "../Components/Transl/Transl";
import CategoryTable from "../Components/Products/SubCategory/CategoryTable";

function SubCategoryOfProducts() {
  return (
    <div>
      <div className="flex justify-between items-center py-7 px-10">
        <Btn />
      </div>
      <div className="px-10">
        <CategoryTable />
      </div>
    </div>
  );
}

export default SubCategoryOfProducts;
